import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { PayrollLogs } from "../entity/payroll-log";
import { InjectRepository } from "@nestjs/typeorm";
import dayjs from "dayjs";
import { PayRollRequest } from "@gtpl/shared-models/hrms";


@Injectable()
@EntityRepository(PayrollLogs)
export class PayrollLogsRepository extends Repository<PayrollLogs> {

    constructor(@InjectRepository(PayrollLogs) private PayrollLogs: Repository<PayrollLogs>
    ) {
        super();
    }

    async getPayrollData(req?: PayRollRequest): Promise<any[]> {
        const query = this.createQueryBuilder('p')
            .select([
                'p.id as id',
                'p.employee_id as employeeId',
                'p.employee_name as employeeName',
                'p.employee_code as employeeCode',
                'p.employee_type as employeeType',
                'p.department as department',
                'p.designation as designation',
                'p.payroll_month as payrollMonth',
                'p.factory_working_days as factoryWorkingDays',
                'p.attendance as attendance',
                'p.basic as basic',
                'p.hra_amount as hraAmount',
                'p.edu_amount as eduAmount',
                'p.medical_amount as medicalAmount',
                'p.spl_amount as splAmount',
                'p.conveyance_amount as conveyanceAmount',
                'p.petrol_Amount as petrolAmount',
                'p.shoe_amount as shoeAmount',
                'p.washing_amount as washingAmount',
                'p.uniform_amount as uniformAmount',
                'p.helper_amount as helperAmount',
                'p.production_amount as productionAmount',
                'p.ta_amount as taAmount',
                'p.bonus_amount as bonusAmount',
                'p.gross as gross',
                'p.incentive_hrs as incentiveHrs',
                'p.cal_basic as calBasic',
                'p.cal_hra as calHra',
                'p.cal_edu as calEdu',
                'p.cal_medical as calMedical',
                'p.cal_spl as calSpl',
                'p.cal_conveyance as calConveyance',
                'p.cal_petrol as calPetrol',
                'p.cal_shoe as calShoe',
                'p.cal_washing as calWashing',
                'p.cal_uniform as calUniform',
                'p.cal_helper as calHelper',
                'p.cal_production as calProduction',
                'p.cal_ta as calTa',
                'p.other_e as otherEarnings',
                'p.cal_bonus as calBonus',
                'p.cal_gross as calGross',
                'p.incentive_amount_per_hr as incentiveAmountPerHr',
                'p.total_incentive_hrs as totalIncentiveHr',
                'p.incentive_amount as incentiveAmount',
                'p.total_earnings as totalEarnings',
                'p.epf_amount as epfAmount',
                'p.esic_amount as esicAmount',
                'p.mess_d as messAmount',
                'p.Professional_tax as ProfessionalTax',
                'p.others_d as othersAmount',
                'p.tds as tds',
                'p.total_deductions as totalDeductions',
                'p.net_salary as netSalary',

            ])
            .where('1=1');

        if (req) {
            if (req.PayrollMonth) {
                const formattedDate = dayjs(req.PayrollMonth).format('YYYYMM');
                query.andWhere('p.payroll_month = :PayrollMonth', { PayrollMonth: formattedDate });
            }

            if (req.department) {
                query.andWhere('p.department = :department', {
                    department: req.department,
                });
            }

            if (req.employeeName) {
                query.andWhere('p.employee_name = :employeeName', {
                    employeeName: req.employeeName,
                });
            }
        }

        return await query.getRawMany();
    }


}

